import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { GradButton, Field } from "@/components/erp";

export const ElleNoDialog = ({ baslik, onClose, onSave }) => {
  const [no, setNo] = useState("");
  const [ettn, setEttn] = useState("");
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-md" data-testid="elle-no-dialog">
        <DialogHeader><DialogTitle className="font-head">{baslik}</DialogTitle></DialogHeader>
        <p className="text-xs text-muted-foreground">Belge QNB portalından veya başka bir yerden kesildiyse numarasını kaydedin. Kontör düşülmez.</p>
        <Field label="Belge no *"><Input data-testid="elle-no" className="bg-white/5 font-mono" value={no} onChange={(e) => setNo(e.target.value)} /></Field>
        <Field label="ETTN (isteğe bağlı)"><Input data-testid="elle-ettn" className="bg-white/5 font-mono" value={ettn} onChange={(e) => setEttn(e.target.value)} /></Field>
        <div className="flex justify-end gap-2"><button onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm" data-testid="elle-vazgec">Vazgeç</button>
          <GradButton disabled={!no.trim()} onClick={() => onSave({ elle: true, belge_no: no, ettn })} data-testid="elle-kaydet">Kaydet</GradButton></div>
      </DialogContent>
    </Dialog>
  );
};
